import { useCall } from '../hooks/useCall'
import { useLightMode } from '@/hooks/useLightMode'

import { Box, Tooltip, useDisclosure } from '@chakra-ui/react'

import { DarkProvider, UtilityButton } from '@hivewatch/dark'

import { EmergencyCall } from '@/components/icons'
import { MixpanelDataIProps } from '@/features/incident-drawer'
import { IncidentQuery } from '@/graphql/generated/operations'

import { ConfirmEmergencyCallDialog } from './ConfirmEmergencyCallDialog'

interface EmergencyCallButtonIProps {
  incident: IncidentQuery['incident']
  mixpanelData?: MixpanelDataIProps
}

export const EmergencyCallButton = ({
  incident,
  mixpanelData,
}: EmergencyCallButtonIProps) => {
  const colorScheme = useLightMode()
  const { isOpen, onClose, onOpen } = useDisclosure()
  const { isOpen: isCallOpen, openCall } = useCall()

  const handleCallClick = () => {
    openCall(
      {
        incidentId: incident?.id,
        incidentDisplayId: incident?.displayId,
        facilityName: incident?.facility?.name,
        emergencyNumber: incident?.facility?.emergencyNumber,
      },
      mixpanelData
    )
    onClose()
  }

  // TODO: use design token when Tooltip bg supports CSS variable tokens
  const bgColor = '#1b253f'
  const emergencyIconColor = 'var(--hw-dark-colors-interactive-danger, #E53E3E)'

  return (
    <>
      <Tooltip
        bg={bgColor}
        color='white'
        hasArrow
        isDisabled={isCallOpen}
        label='Emergency Call'
        mt='5px'
        openDelay={250}
        p='10px'
      >
        <Box as='span' display='inline-block'>
          <DarkProvider>
            <UtilityButton
              colorScheme={colorScheme}
              disabled={isCallOpen}
              icon={
                <Box
                  as='span'
                  display='inline-flex'
                  sx={{ '& svg': { width: '20px', height: '20px' } }}
                >
                  <EmergencyCall
                    strokeColor={emergencyIconColor}
                    strokeWidth={4}
                  />
                </Box>
              }
              iconColor={emergencyIconColor}
              label='Emergency Call'
              onClick={onOpen}
            />
          </DarkProvider>
        </Box>
      </Tooltip>
      {isOpen && (
        <ConfirmEmergencyCallDialog
          emergencyNumber={incident?.facility?.emergencyNumber}
          handleOnClick={handleCallClick}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </>
  )
}
